export const ALL_AUTHORIZATIONS_VALUE = 'allAuthorizations'

export const allAuthorizationsOption = {
  label: 'All Authorizations',
  value: ALL_AUTHORIZATIONS_VALUE,
  key: ALL_AUTHORIZATIONS_VALUE,
}
